import React from 'react';
import { CardHeader } from '@mui/material';
import { customSizes, spaces } from '../../../../assets/styles/themes/tokens';
import { ArtifactCardAvatar, ArtifactCardTitle, ArtifactCardSubheader } from './components';
import { GeneratedArtifactType } from '@kimuno/api-sdk/lib/types/responses/Ai';

interface ArtifactCardHeaderProps {
  title: string;
  createdAt?: number;
  type: GeneratedArtifactType;
}

const cardHeaderSx = {
  display: 'flex',
  alignItems: 'flex-start',
  padding: spaces.md,
  overflow: 'hidden',
};

const cardHeaderSlotProps = {
  avatar: { sx: { marginRight: spaces.xs } },
  content: {
    sx: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      height: customSizes.artifactCard.avatarSize,
    },
  },
};

const ArtifactCardHeader: React.FC<ArtifactCardHeaderProps> = ({ title, createdAt, type }) => (
  <CardHeader
    data-testid='artifact-card-header'
    sx={cardHeaderSx}
    slotProps={cardHeaderSlotProps}
    avatar={<ArtifactCardAvatar type={type} />}
    title={<ArtifactCardTitle title={title} />}
    subheader={<ArtifactCardSubheader createdAt={createdAt} />}
  />
);

export default ArtifactCardHeader;
